import { deviceType } from '@/utils/common'
import MobileReferralsProgram from './mobile/referrals/program.vue'
import PcReferralsProgram from './pc/referrals/program/index.vue'

const basePath = '/recruiting/personal/referral'

export default {
  path: `${basePath}/program`,
  component: deviceType.isPc ? PcReferralsProgram : MobileReferralsProgram,
  meta: {
    isAllInclude: true,
    titleI18nKey: 'personal.menu.referralProgram',
    canEmployee: true,
    rootLayout: {
      hiddenPageHeader: true,
      hiddenPageMenu: true
    },
    mobileFlexible: true
  }
}
